import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

const revokePublicApiKey = (apiToken: string) => {
  const newEndpoints = endpoints.integrations.revokePublicApiKey;
  return http().post(
    newEndpoints,
    {},
    {
      headers: {
        'X-Authorization': apiToken,
      },
    }
  );
};

export function useRevokePublicApiKey() {
  return useMutation({ mutationFn: revokePublicApiKey });
}
